import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from 'antd';
import { useState } from 'react';
export const SubmitButton = ({ onClick: propOnclick, delay, ...props }) => {
    const [loading, setLoading] = useState(false);
    const onClick = (e) => {
        setLoading(() => {
            propOnclick?.(e);
            return true;
        });
        setTimeout(() => {
            setLoading(false);
        }, delay ?? 2000);
    };
    return _jsx(Button, { ...props, loading: loading, onClick: onClick });
};
